module.exports = __webpack_public_path__ + "img/marry-fit-male-6.6b5ff50b.png";